"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var home_svg_1 = __importDefault(require("../../../assets/icons/navegacao/home.svg"));
var login_svg_1 = __importDefault(require("../../../assets/icons/navegacao/login.svg"));
var logout_svg_1 = __importDefault(require("../../../assets/icons/navegacao/logout.svg"));
var menu_svg_1 = __importDefault(require("../../../assets/icons/navegacao/menu.svg"));
var more_horiz_svg_1 = __importDefault(require("../../../assets/icons/navegacao/more_horiz.svg"));
var more_vert_svg_1 = __importDefault(require("../../../assets/icons/navegacao/more_vert.svg"));
var pause_svg_1 = __importDefault(require("../../../assets/icons/navegacao/pause.svg"));
var play_arrow_svg_1 = __importDefault(require("../../../assets/icons/navegacao/play_arrow.svg"));
var skip_next_svg_1 = __importDefault(require("../../../assets/icons/navegacao/skip_next.svg"));
var skip_previous_svg_1 = __importDefault(require("../../../assets/icons/navegacao/skip_previous.svg"));
var stop_svg_1 = __importDefault(require("../../../assets/icons/navegacao/stop.svg"));
var Navegacao = {
    "home": home_svg_1.default,
    "login": login_svg_1.default,
    "logout": logout_svg_1.default,
    "menu": menu_svg_1.default,
    "more_horiz": more_horiz_svg_1.default,
    "more_vert": more_vert_svg_1.default,
    "pause": pause_svg_1.default,
    "play_arrow": play_arrow_svg_1.default,
    "skip_next": skip_next_svg_1.default,
    "skip_previous": skip_previous_svg_1.default,
    "stop": stop_svg_1.default,
};
exports.default = Navegacao;
